import { AlarmListFilters } from '@hakimo-ui/hakimo/types';
import { ColumnsMenu } from '@hakimo-ui/hakimo/ui-table';
import { Button } from '@hakimo-ui/shared/ui-base';
import { FunnelIcon } from '@heroicons/react/24/outline';
import { Fragment } from 'react';
import { AlarmColumn, isNotDefaultFilter } from '../util';

interface Props {
  selectableColumns: AlarmColumn[];
  alarmListShownColumns: string[];
  alarmListFilters: AlarmListFilters;
  onOpenFilterPanel: () => void;
  onChangeShownColumns: (columnIds: string[]) => void;
}

function AlarmListHeader(props: Props) {
  const {
    selectableColumns,
    alarmListShownColumns,
    alarmListFilters,
    onOpenFilterPanel,
    onChangeShownColumns,
  } = props;

  return (
    <Fragment>
      <ColumnsMenu
        options={selectableColumns}
        shownColumns={alarmListShownColumns}
        onChangeShownColumns={onChangeShownColumns}
      />
      <Button
        variant="icon"
        badge={isNotDefaultFilter(alarmListFilters)}
        onClick={onOpenFilterPanel}
        trackingInfo="Open alarms filter panel"
      >
        <span className="sr-only">Open filters panel</span>
        <FunnelIcon className="h-5 w-5" aria-hidden="true" />
      </Button>
    </Fragment>
  );
}

export default AlarmListHeader;
